import { render } from "./PartsServicesForm.vue?vue&type=template&id=87754238"
import script from "./PartsServicesForm.vue?vue&type=script&lang=js"
export * from "./PartsServicesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__